export default {
  submit: 'Submit',
  numberOfAtt: 'Number of attendance',
  email: 'Email',
  phone: 'Tel',
  name: 'Name',
  company: 'Company',
  welcome: 'Welcome to the booth of Truking! Please fill in your information and we will send you the product materials you are interested in. Thank you!',
  signIn: 'Sign-in',
  ctkj: 'Truking Technology Limited',
  zhCN: '中文',
  enUs: 'English',
  esEs: 'Español',
  deDe: 'Deutsch',
  ruRu: 'Русский язык',
  new_dept: 'Department',
  new_title: 'Position',
  new_nation: 'Country',
  new_product: 'Product type',
  requiredMsg: 'Please fill in the required fields',
  successMsg: 'Submitted successfully',
  jobNumber: 'Staff ID',
  jobNumberPlaceholder: 'Please input staff ID',
  passwordReset: 'Password reset',
  jobNumberRule1: 'Please fill in your staff ID',
  jobNumberRule2: 'Please input the correct staff ID',
  verificationCode: 'Verification code',
  verificationCodePlaceholder: 'Please input verification code',
  sendCode: 'Send code',
  codeNotice: 'The verification code will be sent to DingTalk, valid for 2 minutes',
  newPwd: 'New password',
  newPwdRule1: 'Please input new password',
  newPwdRule2: 'The password needs to contain letters, numbers, and symbols（.!@#）, and the length should not be less than 10 characters',
  confirmPwd: 'Confirm new password',
  confirmPwdRule1: 'Confirm new password',
  confirmPwdRule2: 'The passwords entered twice are inconsistent',
  backHome: 'Home page',
  changePwd: 'Change password',
  editSucess: 'Modification successful',
  editPwdError1: 'Password reset failed. The password must be at least 10 characters long and include a combination of letters, numbers, and special characters (such as .!@#)',
  sendSucess: 'Send successfully',
  sendAagain: 'Resending',
  new_tkproduct: 'Interested Products or Solutions',
  jbxx: 'Basic',
  sbzl: 'Documentation',
  gzt: 'Workbench',
  sbxlh: 'SN',
  zjbm: 'Identifier',
  sbmc: 'Device Name',
  ggxh: 'Model',
  bxjzrq: 'Warranty Expiration Date',
  zbq: 'Warranty Period',
  zwwj: 'No files available',
  sbbx: 'Equipment Repair',
  back: 'Back',
  add: 'Add',
  nomore: 'No more data',
  nodata: 'No data',
  tc: 'Discontinued',
  scz: 'In Production',
  wtms: 'Issue',
  lxfs: 'Contact Info',
  ckcljd: 'View Progress',
  sqcljd: 'Collapse Progress',
  ts: 'Notice',
  qrsfsc: 'Are you sure you want to delete this record?',
  qtxxm: 'Please enter your name',
  qsrsbycxx: 'Please describe the device issue, error messages, and operation steps.',
  sbsyzt: 'Device Status',
  qtxdhhyx: 'Please enter your phone number or email address',
  attach: 'Attachment',
  qsczp: 'Please upload photos',
  ygb: 'Expired ',
  gbt: ' days ago',
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-US.js